import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import SideBar from '../../components/SideBar/SideBar';
import {
  Alert,
  Button,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  InputGroup,
  Row,
} from 'react-bootstrap';
import {
  ErrorMessage,
  Field,
  Form,
  Formik,
} from 'formik';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import * as yup from 'yup';
import cx from 'classnames';
import MaterialSettings from './MaterialSettings';
import { withTranslation } from 'react-i18next';
import { toNumber } from '../../utils/numbers';
import InventoryAdjustModal from './InventoryAdjust';
import ShipInMaterial from './ShipInMaterial/ShipInMaterial';
import moment from 'moment';
import PropTypes from 'prop-types';
import EditDevice from '../Devices/EditDevice';
import { canBatch } from '../../stores/batch/can-batch';

class BatchMaterial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editingMaterial: null,
      adjustingMaterialId: null,
      shipInMaterialId: null,
      error: '',
      warning: '',
    };

    this.schema = null;
  }

  componentWillMount() {
    const { materialStore } = this.props;
    if (!materialStore.materials.length) {
      materialStore.loadMaterials();
    }

    this.setSchema();
  }

  initialData() {
    const { materialStore } = this.props;
    const { water } = materialStore;
    const details = water ? materialStore.materialDetails[water.materialDetailId] : null;

    return {
      materialId: water ? water.itemId : null,
      quantity: '',
      moisture: 0,
      unit: details ? details.itemBatchUnitSymbol : 'unit',
      binPercent: {},
    };
  };

  setSchema() {
    this.schema = yup.object().shape({
      materialId: yup.number().required('Required!'),
      quantity: yup.number().min(1, 'Minimum: 1').required('Required!'),
      moisture: yup.number().min(-100, 'Minimum: -100').max(100, 'Maximum: 100'),
    });
  }

  getMoisture(materialId) {
    const { materialStore } = this.props;
    const material = materialStore.materials.find(v => v.itemId === Number(materialId));
    const md = material ? materialStore.materialDetails[material.materialDetailId] || {} : {};

    if (md.autoMoisture && md.autoMoistureAmount) {
      return toNumber(md.autoMoistureAmount, 2);
    }

    return toNumber(md.moistureAmount || 0, 2);
  }

  getFinalQuantity(values = {}) {
    const { materialStore } = this.props;
    const material = values.materialId ? materialStore.materials.find(v => v.itemId === Number(values.materialId)) : null;
    const md = material ? materialStore.materialDetails[material.materialDetailId] || {} : {};
    const absorption = md.absorption || 0;

    return toNumber(values.quantity + ((values.moisture*values.quantity - absorption*values.quantity)/100));
  }

  isAggregate = materialId => {
    return this.props.materialStore.isAggregate(materialId);
  };

  startMaterialEdit = materialId => {
    this.resetState();
    const { materialStore } = this.props;
    const material = materialStore.getMaterialByItemId(materialId);
    this.setState({ editingMaterial: material });
  };

  startMaterialAdjust = materialId => {
    this.resetState();
    this.setState({ adjustingMaterialId: materialId });
  };

  startMaterialShipIn = materialId => {
    this.resetState();
    const { materialStore } = this.props;
    const material = materialStore.getMaterialByItemId(materialId);

    if (material) {
      this.setState({ shipInMaterialId: material.inventoryItemId});
    }
  };

  onDemoClick = (submitForm) => {
    const { batchStore, diagnoseStore } = this.props;
    if (!batchStore.isDemo && batchStore.running.length) {
      batchStore.showWarning('Can\'t run DEMO while batching!');
      return;
    }

    if (diagnoseStore.isTesting) {
      batchStore.showWarning('Can\'t run DEMO while running Diagnose Auto Test!');
      return;
    }

    batchStore.isDemo = true;
    submitForm();
  };

  onBatchClick = (submitForm) => {
    const { batchStore, diagnoseStore } = this.props;
    if (batchStore.isDemo && batchStore.running.length) {
      batchStore.showWarning('Can not BATCH while running DEMO!');
      return;
    }

    if (diagnoseStore.isTesting) {
      batchStore.showWarning('Can not BATCH while running Diagnose Auto Test!');
      return;
    }

    batchStore.isDemo = false;
    submitForm();
  };

  onResetForm = resetForm => {
    resetForm({
      values: this.initialData(),
    });
    this.resetState();
  };

  resetState = () => {
    this.setState({
      error: '',
      warning: '',
      editingMaterial: null,
      adjustingMaterialId: null,
      shipInMaterialId: null,
      jogTableMaterialId: null,
    });
  };

  onSubmit = (values, actions) => {
    const { batchStore, sidebarStore, settingsStore } = this.props;

    Object.keys(values.binPercent).forEach(binId => {
      if (!values.binPercent[binId]) {
        delete values.binPercent[binId];
      }
    });

    const data = batchStore.getInitialMaterialData({
      ...values,
      quantity: this.isAggregate(values.materialId) ? this.getFinalQuantity(values) : values.quantity,
    });

    const verification = canBatch(data, settingsStore.rootStore);

    this.setState({
      error: verification.errors.length ? verification.errors.map(v => v.error).join(' ') : '',
      warning: verification.warnings.length ? verification.warnings.join(' ') : '',
    });

    if (!verification.isValid) {
      actions.setSubmitting(false);
      return;
    }

    setTimeout(() => {
      actions.setSubmitting(false);
      batchStore.initData({ ...data, loadStartTime: moment().tz(batchStore.timezone).format() });
      sidebarStore.onToggle(null);
      actions.resetForm({
        values: this.initialData(),
      });
      this.resetState();
    }, 1000);

  };

  getBinPercent(materialId) {
    const  { materialStore, devicesStore } = this.props;
    const material = materialId ? materialStore.getMaterialByItemId(materialId) : null;
    const md = material ? materialStore.materialDetails[material.materialDetailId] : null;
    const binPercent = {};
    const bins = devicesStore.getActiveBinsForMultiScale(material, true);

    if (!bins) {
      return {};
    }

    if (md?.bins?.length) {
      md.bins.filter(v => v.isActive && v.split).forEach(v => binPercent[v.binId] = v.split);
    }

    return binPercent;
  }

  renderRow(values, handleChange, errors, touched, setValues) {
    const { materialStore, t } = this.props;
    const { materialsWithDetails } = materialStore;
    const material = values.materialId ? materialStore.getMaterialByItemId(values.materialId) : null;

    return (
      <React.Fragment>
        <Row>
          <Col sm={4}>
            <ControlLabel data-e2e-id="lbl-material-batch-material">{t('Material')}</ControlLabel>
            <FormGroup className={cx({'has-error': errors.materialId && touched.materialId} )}>
              <FormControl
                data-e2e-id="dpd-material-batch-material"
                name="materialId"
                key="materialId"
                componentClass="select"
                value={values.materialId || ''}
                onChange={e => {
                  const materialId = e.target.value;
                  const unit = materialStore.getMaterialUnitSymbol(materialId);
                  this.resetState();
                  setValues({
                    ...values,
                    materialId,
                    unit,
                    moisture: this.getMoisture(materialId),
                    binPercent: this.getBinPercent(materialId),
                  });
                }}
                bsSize="sm"
              >
                <option value=""/>
                {materialsWithDetails.map(material => (
                  <option key={material.itemId} value={material.itemId}>
                    {materialStore.getMaterialName(material)}
                  </option>
                ))}
              </FormControl>
              <ErrorMessage component="span" name={'materialId'} className="help-block" />
              {!materialStore.isDeviceSetToMaterial(values.materialId) &&
              <div className="has-error"><span className="help-block">{t('No device set')}!</span></div>
              }
            </FormGroup>
          </Col>
          <Col sm={3}>
            <ControlLabel data-e2e-id="lbl-material-batch-quantity">{t('Qty')}</ControlLabel>
            <FormGroup className={cx({'has-error': errors.quantity && touched.quantity} )}>
              <InputGroup>
                <FormControl
                  data-e2e-id="inp-material-batch-quantity"
                  key="quantity"
                  name="quantity"
                  type="number"
                  min="1"
                  max="100000"
                  value={isNaN(values.quantity) ? '' : values.quantity}
                  onChange={handleChange}
                  bsSize="sm"
                />
                <InputGroup.Addon>
                  {values.unit}
                </InputGroup.Addon>
              </InputGroup>
              <ErrorMessage component="span" name={'quantity'} className="help-block" />
            </FormGroup>
          </Col>

          {!values.materialId || !material || !this.isAggregate(values.materialId) ? '' : (
            <React.Fragment>
              <Col sm={3}>
                <ControlLabel data-e2e-id="lbl-material-batch-moisture">{t('Moist%')}</ControlLabel>
                <FormGroup className={cx({'has-error': errors.moisture && touched.moisture} )}>
                  <InputGroup>
                    <FormControl
                      data-e2e-id="inp-material-batch-moisture"
                      name="moisture"
                      key="moisture"
                      type="number"
                      min="-100"
                      max="100"
                      step="0.01"
                      value={isNaN(values.moisture) ? '' : values.moisture}
                      onChange={handleChange}
                      bsSize="sm"
                    />
                    <InputGroup.Addon>
                    %
                    </InputGroup.Addon>
                  </InputGroup>
                  <ErrorMessage component="span" name={'moisture'} className="help-block" />
                </FormGroup>
              </Col>
              <Col sm={2}>
                <FormGroup>
                  <ControlLabel data-e2e-id="lbl-material-batch-net">{t('Net')}</ControlLabel>
                  <div className="form-data-value" data-e2e-id="lbl-material-batch-net-value">
                    {toNumber(this.getFinalQuantity(values) || 0, 1)}
                  </div>
                </FormGroup>
              </Col>
            </React.Fragment>
          )}

        </Row>
      </React.Fragment>
    );
  };

  renderSubmit(values, handleSubmit, submitForm, resetForm, isSubmitting) {
    const { t } = this.props;

    return (
      <React.Fragment>
        <Row>
          <Col sm={12}>
            {!!this.state.error && <Alert bsStyle="danger">{this.state.error}</Alert>}
            {!!this.state.warning && <Alert bsStyle="warning">{this.state.warning}</Alert>}
          </Col>
          <Col sm={12} className="text-right">
            <p>
              <Button bsSize="xs" onClick={() => this.startMaterialEdit(values.materialId)} title={t('Edit')} data-e2e-id="btn-material-batch-edit">
                <i className="fa fa-fw fa-pencil" />
              </Button>
              {' '}
              <Button bsSize="xs" onClick={() => this.startMaterialShipIn(values.materialId)} title={t('Ship In')} data-e2e-id="btn-material-batch-ship-in">
                <i className="fa fa-fw fa-truck" />
              </Button>
              {' '}
              <Button bsSize="xs" onClick={() => this.startMaterialAdjust(values.materialId)} title={t('Inventory Adjustment')} data-e2e-id="btn-material-batch-inventory-adjust">
                <i className="fa fa-fw fa-sliders" />
              </Button>
            </p>
            <p>
              <Button onClick={() => this.onResetForm(resetForm)} title={t('Reset')} data-e2e-id="btn-material-batch-reset">{t('Reset')}</Button>
              {' '}
              <Button onClick={() => this.onDemoClick(submitForm)} title={t('Demo')} data-e2e-id="btn-material-batch-demo">{t('Demo')}</Button>
              {' '}
              <LoadingButton
                data-e2e-id="btn-material-batch-batch"
                bsStyle="primary"
                onClick={() => this.onBatchClick(submitForm)}
                label="Batch"
                loadingLabel="Saving"
                isLoading={isSubmitting}
              />
            </p>
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  renderMaterialDivisionRow(values, setValues) {
    const { devicesStore, materialStore, t } = this.props;
    const material = materialStore.getMaterialByItemId(Number(values.materialId));
    const bins = devicesStore.getActiveBinsForMultiScale(material, true);

    const getValuePerBin = (binId) => {
      const qty = values.quantity || 0;
      const percent = values.binPercent[binId] || 0;

      return toNumber(qty * percent/100, 1);
    };

    const getTotalBinPercent = () => {
      let percent = 0;
      Object.values(values.binPercent).forEach(v => {
        percent += Number(v) || 0;
      });

      return percent;
    };

    const onPercentChange = (value, binId) => {
      if (Number(value) >= 100) {
        Object.keys(values.binPercent).forEach(bId => {
          if (binId !== bId) {
            values.binPercent[bId] = 0;
          }
        });
      }

      values.binPercent[binId] = Number(value);

      setValues(values);
    };

    return bins && bins.length
      ? (
        <div className="material-division-wrap">
          {bins.map((bin) => (
            <Row key={bin.id}>
              <Col sm={1} xs={1}/>
              <Col sm={3} xs={3}>
                <ControlLabel>{t('Bin')}</ControlLabel>
                <div className="form-data-value">
                  {bin.description}
                </div>
              </Col>
              <Col sm={3} xs={3}>
                <ControlLabel>{t('Split')}</ControlLabel>
                <FormGroup className={getTotalBinPercent() > 100 ? 'has-error' : ''}>
                  <InputGroup>
                    <Field name={`binPercent.${bin.id}`}
                      type="number"
                      min={0}
                      max={100}
                      maxLength={3}
                      step={1}
                      value={values.binPercent[bin.id] || ''}
                      onChange={e => onPercentChange(e.target.value, bin.id)}
                      className="form-control input-sm narrow-pad"/>
                    <InputGroup.Addon>
                    %
                    </InputGroup.Addon>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col sm={3} xs={3}>
                <FormGroup>
                  <ControlLabel>{t('Qty')}</ControlLabel>
                  <div className="form-data-value">
                    {toNumber(getValuePerBin(bin.id) || 0, 1)}
                  </div>
                </FormGroup>
              </Col>
            </Row>
          )
          )}
        </div>
      )

      : '';
  }

  renderForm() {
    return (
      <Formik
        enableReinitialize
        initialValues={
          this.initialData()
        }
        validateOnChange={true}
        validationSchema={this.schema}
        onSubmit={this.onSubmit}
      >{({ handleSubmit,
          handleChange,
          setValues,
          values,
          errors,
          touched,
          isSubmitting,
          resetForm,
          submitForm,
        }) => (
          <Form className={'batch-material-form'}>
            {this.renderRow(values, handleChange, errors, touched, setValues)}
            {this.renderMaterialDivisionRow(values, setValues)}
            {this.renderSubmit(values, handleSubmit, submitForm, resetForm, isSubmitting)}
          </Form>

        )}
      </Formik>
    );
  };

  render() {
    const { materialStore, devicesStore } = this.props;
    const { editingMaterial, adjustingMaterialId, shipInMaterialId } = this.state;
    const { isEditing: editingDevice } = devicesStore;

    return !materialStore.materialDetailsLoaded ? '' : (
      <SideBar type="batchMaterial" title={'Batch material'} icon={'fa-file-text-o'}>
        {this.renderForm()}
        {editingDevice && (
          <EditDevice />
        )}
        {editingMaterial && (
          <MaterialSettings
            editingMaterial={editingMaterial}
            cancelEdit={this.resetState}
          />
        )}
        {adjustingMaterialId && (
          <InventoryAdjustModal
            materialId={adjustingMaterialId}
            onClose={this.resetState}
          />
        )}
        {shipInMaterialId && (
          <ShipInMaterial
            inventoryId={shipInMaterialId}
            onClose={this.resetState}
          />
        )}
      </SideBar>
    );
  };
}

export default withTranslation()(inject('batchStore', 'sidebarStore', 'materialStore', 'diagnoseStore', 'devicesStore', 'settingsStore')(observer(BatchMaterial)));

BatchMaterial.propTypes = {
  batchStore: PropTypes.object,
  sidebarStore: PropTypes.object,
  materialStore: PropTypes.object,
  diagnoseStore: PropTypes.object,
  devicesStore: PropTypes.object,
  settingsStore: PropTypes.object,
  t: PropTypes.func,
};
